import { EventrDate, TItineraryEntry } from "@eventr/common";
import i18n from "i18n/i18next";

export const toMs = (t: number) => t * 1000;

export const isNewEntry = (component: TItineraryEntry): boolean => {
  if (!("created_at" in component) || !("updated_at" in component)) {
    return false;
  }

  if (typeof component.created_at !== "number" || typeof component.updated_at !== "number") {
    return false;
  }

  return Math.abs(component.created_at - component.updated_at) < 300; // 5 minutes
};

export const formatRelativeDayLabel = (dateInput: string | number) => {
  const d = new EventrDate(dateInput);
  const now = new EventrDate();

  const inputDateStr = d.toItinLocalDateString();
  const todayStr = now.toItinLocalDateString();

  if (inputDateStr === todayStr) {
    return i18n.t("activityFeed.today");
  }

  const yesterdayStr = now.subtract({ days: 1 }).toItinLocalDateString();
  if (inputDateStr === yesterdayStr) {
    return i18n.t("activityFeed.yesterday");
  }

  return d.toFormattedString({ zoneType: "userLocal", format: { dateStyle: "short" } });
};

export const getEntryTimestamp = (component: TItineraryEntry): number => {
  if ("updated_at" in component && typeof component.updated_at === "number") {
    return toMs(component.updated_at);
  }

  if ("created_at" in component && typeof component.created_at === "number") {
    return toMs(component.created_at);
  }

  return 0;
};
